import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function LoginApproved({ baseUrl, onLoginSuccess }) {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const token = searchParams.get("token");
        const role = searchParams.get("role");
        const name = searchParams.get("name");

        const channel = new BroadcastChannel("chamcore-login");
        channel.postMessage({
            type: "LOGIN_APPROVED",
            token,
            role,
            name,
        });
        channel.close();

        // Optionally close tab automatically
        setTimeout(() => window.close(), 2000);
    }, [searchParams]);

    return (
        <div className="p-6 text-center">
            <h1 className="text-xl font-bold">Logg in godkjent</h1>
            <p>Takk for at du godkjenner Logg in.</p>
        </div>
    );
}
